export enum AcaoTagsNFeSaidaEnum {
  Incluir = 1,
  Remover = 2,
}
